import hx from "../utils/hydroxie";
import { ContentControl } from "../utils/maputil/legendcontrol";

/**
 * 震源の凡例
 */
export class EpicenterLegendControl extends ContentControl {
    /**
     * コンストラクター。
     */
    constructor() {
        const content = hx("div", { className: "ol-epicenter-legend-control-content" });
        const style = {
            bottom: "2.5em",
            right: "0.5em",
        };

        super({ content, style });

        const df = hx("",
            hx("div", this.#createImage(9)),
            hx("div", "M9"),
            hx("div", this.#createImage(8)),
            hx("div", "M8"),
            hx("div", this.#createImage(7)),
            hx("div", "M7"),
            hx("div", this.#createImage(6)),
            hx("div", "M6"),
            hx("div", this.#createImage(5)),
            hx("div", "M5"),
            hx("div", this.#createImage(4)),
            hx("div", "M4"),
            hx("div", this.#createImage(3)),
            hx("div", "M3"),
            hx("div", this.#createImage(2)),
            hx("div", "M2"),
            hx("div", this.#createImage(1)),
            hx("div", "M1"));

        content.replaceChildren(df);
    }

    #createImage(magnitude: number) {
        const radius = magnitude * 2;
        const canvasSize = radius * 2 + 2;
        const center = radius + 1;

        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("viewbox", `0 0 ${canvasSize} ${canvasSize}`);
        svg.setAttribute("width", "" + canvasSize);
        svg.setAttribute("height", "" + canvasSize);
        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("cx", "" + center);
        circle.setAttribute("cy", "" + center);
        circle.setAttribute("r", "" + radius);
        circle.setAttribute("fill", "#b3bdffb3");
        circle.setAttribute("stroke", "#2942ff");
        circle.setAttribute("stroke-width", "1");

        svg.append(circle);

        return svg;
    }
}
